import Snackbar from "../components/Snackbar";

const snackbar = {
    created(){
        this.$store.commit('updateShowSnackbar', false);
    },
    components: {
        Snackbar
      },
      data: () => ({
        snackbarMessage: '',
        snackbarColor: ''
      }),
      methods: {
        showSnackbar(message, color) {
          this.snackbarMessage = message;
          this.snackbarColor = color;
          this.$store.commit('updateShowSnackbar', true);
        }
      }
};
export default snackbar;